
	jQuery( document ).ready(function() {

		/*jQuery(window).bind('mousewheel', function() {
			return false;
    	});

    	jQuery(".vid-text").addClass('anim-down');


		/*jQuery( "div" ).data( "test", {
			first: "1. we help brands <strong>explode.</strong>",
			second:  "2. we help brands <strong>explode.</strong>",
			third: "3. we help brands <strong>implode.</strong>"
		});

		jQuery( ".feature-text" ).text( jQuery( "div" ).data( "test" ).first );*/


		//jQuery(".vid-text").css("opacity","1");	

		/*var debounce = null;

		function onWheel(event) {
			//console.log(jQuery(window).scrollTop());


			var threshold = jQuery(window).scrollTop();

			console.log(threshold);

			if (debounce) clearTimeout(debounce);
			debounce = setTimeout(function(){

				var threshold = jQuery(document).scrollTop();

				//remove reference so another delay can start
				//debounce = null;

				if(event.deltaY > 0)
				{
					console.log('Scroll Down'); //your scroll data here	
					var current = jQuery('.current');
					var currentText = jQuery('.text-wrapper .current');

					if(!current.is(':last-child'))
					{
						current.removeClass('current').fadeOut();
						current.next().addClass('current').fadeIn();

						currentText.removeClass('anim-down anim-up');
						currentText.next().addClass('anim-down');						
					}
					else {
						//current.removeClass('current').animate({'top':'-100%'});
						//$('body').css('overflow','scroll');
						//past = false;

						/*jQuery('#home-top').removeClass('fixed');

						jQuery(window).bind('mousewheel', function() {
							return true;
				    	});*/

					/*}
				}
				else if(event.deltaY < 0)
				{
					console.log('Scroll up'); //your scroll data here
					var current = jQuery('.current');
					var currentText = jQuery('.text-wrapper .current');
					
					if(!current.is(':first-child'))
					{
						current.removeClass('current').fadeOut();
						current.prev().addClass('current').fadeIn();

						currentText.removeClass('anim-down anim-up');
						currentText.prev().addClass('anim-up');	
					}
				}
				//perform whatever logic you normally would do
			}, 50);
		}
		document.addEventListener('wheel', onWheel);	
*/

	});
